import { HomeLink } from "../chrome/home-link.js";
import { Icon, type IconName } from "../chrome/icons.js";
import { COVER_ID, seedSrc } from "../seed.js";

export interface IntroScreenProps {
  readonly hostName?: string | null;
  onStart(): void;
}

const SIDES: readonly (readonly [IconName, string, string])[] = [
  ["grid", "Seu painel", "Você cria o evento com a sua marca e acompanha tudo."],
  ["camera", "O celular do convidado", "Ele entra pelo QR, sem instalar nada, e fotografa."],
  ["monitor", "O telão", "As fotos entram ao vivo, com o nome de quem tirou."],
];

const CLIENT_SIDES: readonly (readonly [IconName, string, string])[] = [
  ["camera", "O celular dos convidados", "Eles entram pelo QR, sem instalar nada, e fotografam."],
  ["monitor", "O telão", "As fotos entram ao vivo, com o nome de quem tirou."],
  ["images", "O seu álbum", "No dia seguinte, tudo separado por horário, em qualidade original."],
];

export function IntroScreen({ hostName = null, onStart }: IntroScreenProps) {
  const sides = hostName ? CLIENT_SIDES : SIDES;
  return (
    <div class="d-screen d-scroll d-intro" data-theme="dark" data-testid="screen-intro">
      <div class="d-cover">
        <img src={seedSrc(COVER_ID, "l")} alt="" />
        <span class="d-veil-soft" />
        <span class="d-veil-bottom" />
      </div>
      {hostName ? null : (
        <div class="d-intro-home">
          <HomeLink />
        </div>
      )}
      <main class="d-intro-body">
        {hostName ? (
          <>
            <p class="d-micro">{hostName} apresenta</p>
            <h1 class="d-intro-title">
              Veja como fica <em>o seu evento</em>
            </h1>
          </>
        ) : (
          <>
            <p class="d-micro">Kuori para cerimonialistas</p>
            <h1 class="d-intro-title">
              Veja o seu evento <em>dos três lados</em>
            </h1>
          </>
        )}
        <ul class="d-intro-sides">
          {sides.map(([icon, title, body]) => (
            <li key={title}>
              <Icon name={icon} />
              <div>
                <strong>{title}</strong>
                <span>{body}</span>
              </div>
            </li>
          ))}
        </ul>
        <button type="button" class="d-button d-primary d-large" onClick={onStart}>
          Começar
        </button>
        <p class="d-caption">
          {hostName
            ? "Leva uns 2 minutos. Nada é enviado: tudo fica neste navegador."
            : "Leva uns 2 minutos. Tudo fica só neste navegador."}
        </p>
      </main>
    </div>
  );
}
